import React from "react";
import { QuickStatsCard } from "@shared/components/QuickStatsCard";
import { Droplet, TrendingDown, TrendingUp, Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useConsumerConsumptionKpi } from "../../hooks";
import { getLoginDataFromStorage } from "@shared/utils/loginUtils";

export const ConsumptionKpiCards = () => {
  const { t } = useTranslation();
  const { remoteUtilityId, remoteConsumerNumber } = getLoginDataFromStorage() || {};

  const { data: kpiData, isLoading: isKpiLoading } = useConsumerConsumptionKpi({
    remote_utility_id: String(remoteUtilityId),
    consumer_no: remoteConsumerNumber,
  }, { enabled: !!remoteUtilityId && !!remoteConsumerNumber });

  const kpiResult = kpiData?.result;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <QuickStatsCard
        title={t("Current Month")}
        displayValue={isKpiLoading ? t("Loading...") : kpiResult?.currentMonth != null ? `${kpiResult.currentMonth} CCF` : "- CCF"}
        trendSummary={isKpiLoading ? "" : kpiResult?.currentMonth != null ? `${(kpiResult.currentMonth * 748).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 })} gal` : "-"}
        icon={
          <div className="bg-blue-50 w-10 h-10 rounded-full flex items-center justify-center">
            <Droplet className="w-5 h-5 text-blue-600" />
          </div>
        }
        className="shadow-sm border-slate-100 bg-white rounded-xl"
      />
      <QuickStatsCard
        title={t("6-Month Average")}
        displayValue={isKpiLoading ? t("Loading...") : kpiResult?.sixMonthAverage != null ? `${kpiResult.sixMonthAverage} CCF` : "- CCF"}
        trendSummary={isKpiLoading ? "" : t("Your baseline")}
        icon={
          <div className="bg-teal-50 w-10 h-10 rounded-full flex items-center justify-center">
            <TrendingDown className="w-5 h-5 text-teal-600" />
          </div>
        }
        className="shadow-sm border-slate-100 bg-white rounded-xl"
      />
      <QuickStatsCard
        title={t("Peak Month")}
        displayValue={isKpiLoading ? t("Loading...") : kpiResult?.peakMonthValue != null ? `${kpiResult.peakMonthValue} CCF` : "- CCF"}
        trendSummary={isKpiLoading ? "" : kpiResult?.peakMonth || "-"}
        icon={
          <div className="bg-orange-50 w-10 h-10 rounded-full flex items-center justify-center">
            <TrendingUp className="w-5 h-5 text-orange-600" />
          </div>
        }
        className="shadow-sm border-slate-100 bg-white rounded-xl"
      />
      <QuickStatsCard
        title={t("vs Avg Household")}
        displayValue={isKpiLoading ? t("Loading...") : kpiResult?.vsAvgHousehold != null ? `${kpiResult.vsAvgHousehold > 0 ? '+' : ''}${kpiResult.vsAvgHousehold} CCF` : "- CCF"}
        trendSummary={
          isKpiLoading ? "" :
          kpiResult?.vsAvgHousehold != null
            ? kpiResult.vsAvgHousehold <= 0
              ? t("Below avg ✓")
              : t("Above avg ↑")
            : "-"
        }
        icon={
          <div className="bg-green-50 w-10 h-10 rounded-full flex items-center justify-center">
            <Info className="w-5 h-5 text-green-600" />
          </div>
        }
        className="shadow-sm border-slate-100 bg-white rounded-xl"
      />
    </div>
  );
};
